
  export const SET_MILESTONEBENEFIT = "SET_MILESTONEBENEFIT";
  export const CREATE_MILESTONEBENEFIT = "CREATE_MILESTONEBENEFIT";
  export const MILESTONEBENEFITS_RECEIVED = "MILESTONEBENEFITS_RECEIVED";
  export const SET_PROPERTY_MILESTONEBENEFIT = "SET_PROPERTY_MILESTONEBENEFIT";
  